import { styled } from '@mui/material';

import type { StyledStackProps } from './types';

export const StyledButton = styled('button')<StyledStackProps>(
  ({ cursor }) => ({
    all: 'unset',
    cursor,
  }),
);
